export const distanceBetweenDots = 60;
export const distanseBetweenLayers = 50;
export const ballDiametr = 20;
export const dotDiametr = 10;
const ballRadius = ballDiametr / 2;
const dotRadius = dotDiametr / 2;
export const maxBallsCount = 10;
export const coeffOffset = 30;
export const coeffElementHeight = 40;
export const coeffElementWidth = distanceBetweenDots - dotDiametr;
export const END_SIMPLE_ANIMATION_TIME = 600;
export const LINE_ANIMATION_TIME = 300;
export const MINI_BOUNCE_ANIMATION_TIME = 500;
export const JUMP_FROM_DOT_TO_DOT_ANIMATION_TIME = 450;
export const BOUNCE_ANIMATION_TIME = 700;
export const PARABOLIC_TIME = 1000;
export const PARABOLIC_ANIMATION_TIME = 500;
export const START_ANIMATION_TIME = 600;

export const line = (p1, p2, t) => (1 - t) * p1 + t * p2;
export const parabolic = (p1, p2, p3, t) => Math.pow(1 - t, 2) * p1 + 2 * (1 - t) * t * p2 + Math.pow(t, 2) * p3;

export const getCenteredCoordinateForAnimation = (dotX, dotY) => {
    return {
            x: dotX + dotDiametr / 2 - ballDiametr / 2,
            y: dotY - ballDiametr,
        }
};
export const getNotCenteredCoordinateForAnimationByAngle = (dotX, dotY, angle) => {
    const dotCenter = {
        x: dotX + dotRadius,
        y: dotY + dotRadius,
    };

    const distanceFromDotCenterToBallBbox = dotRadius + ballRadius + ballRadius * Math.sqrt(2);

    return {
        x: dotCenter.x + distanceFromDotCenterToBallBbox * Math.cos(angle) - (Math.cos(angle) < 0 ? 0 : ballDiametr),
        y: dotCenter.y - distanceFromDotCenterToBallBbox * Math.sin(angle) - (Math.sin(angle) > 0 ? 0 : ballDiametr),
    }

};

export const BallPositionByDot = {
    CENTER: 'center',
    TOP_LEFT: 'top-left',
    TOP_RIGHT: 'top-right',
    BOTTOM_LEFT: 'bottom-left',
    BOTTOM_RIGHT: 'bottom-right',
}

export const getTimeByLayers = (toRowIndex, fromRowIndex, animationTime) => {
    const layersCount = toRowIndex - fromRowIndex;
    return layersCount === 1 ? animationTime : animationTime * layersCount * 0.5;
}